export class StorageConstants {
  public static readonly RM_ECOMMERCE_CART_ITEMS = 'rmEcommerceCartItems';
  public static readonly RM_ECOMMERCE_FREIGHT = 'rmEcommerceFreight';
  public static readonly RM_ECOMMERCE_TOKEN = 'rmEcommerceToken';
  public static readonly RM_ECOMMERCE_USER = 'rmEcommerceUser';
  public static readonly RM_ECOMMERCE_ZIP_CODE = 'rmEcommerceZipCode';
}
